// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiTabs-flexContainer {
  background-color: transparent;
  width: 100%;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.app-logo {
  width: 100px;
  border-radius: 25%;
  box-shadow: rgb(0 0 0 / 30%) 0px 3px 10px -3px;
  height: 100px;
  object-fit: contain;
}

.btn {
  height: 5vh;
  background-color: #0868fe !important;
  border-radius: 10px;
  color: white;
  margin-top: 2vh;
  border: none;
  font-weight: bold;
  cursor: pointer;
  box-shadow: #0868fe 0px 3px 5px -2px !important;
  letter-spacing: 1px; 
  padding: 0 1rem;
}

::-webkit-scrollbar {
    width: 0px;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/Peripherals/AppDetails/index.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,+CAA+C;EAC/C,mBAAmB;EACnB,eAAe;AACjB;;AAEA;IACI,UAAU;AACd","sourcesContent":[".MuiTabs-flexContainer {\n  background-color: transparent;\n  width: 100%;\n  border-radius: 5px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.app-logo {\n  width: 100px;\n  border-radius: 25%;\n  box-shadow: rgb(0 0 0 / 30%) 0px 3px 10px -3px;\n  height: 100px;\n  object-fit: contain;\n}\n\n.btn {\n  height: 5vh;\n  background-color: #0868fe !important;\n  border-radius: 10px;\n  color: white;\n  margin-top: 2vh;\n  border: none;\n  font-weight: bold;\n  cursor: pointer;\n  box-shadow: #0868fe 0px 3px 5px -2px !important;\n  letter-spacing: 1px; \n  padding: 0 1rem;\n}\n\n::-webkit-scrollbar {\n    width: 0px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
